import React, { useState } from "react";
import { GlButton } from "@adl/component-button";
import { GlCallout } from "@adl/component-callout";
import { useTranslations } from "@crystal/translator";
import { requestDoiConfirmation } from "../../lib/index.js";
import styles from "../consents.module.scss.js";
const PendingSubscription = () => {
  const t = useTranslations();
  const [showButton, setShowButton] = useState(true);
  const onClick = async () => {
    const response = await requestDoiConfirmation();
    setShowButton(!response);
  };
  return /* @__PURE__ */ React.createElement(GlCallout, { "data-auto-id": "doi-awaiting-confirmation" }, /* @__PURE__ */ React.createElement("p", { className: styles["pending-subscription-title"] }, t("confirmation.title")), /* @__PURE__ */ React.createElement("p", null, t("confirmation.text")), /* @__PURE__ */ React.createElement(GlButton, { theme: "light", className: "gl-vspace-bpall-small", onClick, disabled: !showButton }, showButton ? t("resend.email.btn") : t("resend.email.sent")));
};
export {
  PendingSubscription
};
//# sourceMappingURL=pending-subscription.js.map
